import { render, staticRenderFns } from "./VirtualWalletPrePurchasedListing.vue?vue&type=template&id=1aa45add&"
import script from "./VirtualWalletPrePurchasedListing.vue?vue&type=script&lang=js&"
export * from "./VirtualWalletPrePurchasedListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports